import { render } from "./ClientePagoList.vue?vue&type=template&id=63e8ab2f&scoped=true"
import script from "./ClientePagoList.vue?vue&type=script&lang=js"
export * from "./ClientePagoList.vue?vue&type=script&lang=js"

import "./ClientePagoList.vue?vue&type=style&index=0&id=63e8ab2f&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e8ab2f"]])

export default __exports__